import { configureStore } from '@reduxjs/toolkit';
import { automotorApi } from './createApi';


export const store = configureStore({
    reducer: {
        [automotorApi.reducerPath]: automotorApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(automotorApi.middleware),
});
